import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { TableComp } from 'sz-react-utils'
import moment from 'moment'
import { Button, Card, Col, InputNumber, Row, Select } from 'antd'
import _ from 'lodash'
import styles from './styles.less'

import Request from '../../request'

import { connect } from 'react-redux'
import common from '../common.less'
import userRights from '../../components/_utils/userRights'

const Option = Select.Option
const typeofDegree = {
    Diploma: [
        { key: 'Diploma Of Engineering', value: 'Diploma Of Engineering' },
        { key: 'Diploma Of Management', value: 'Diploma Of Management' }
    ],
    'Bachelor Degree': [
        { key: 'Bachelor of Agriculture', value: 'Bachelor of Agriculture' },
        { key: 'Bachelor of Arts', value: 'Bachelor of Arts' },
        {
            key: 'Bachelor of Ayurvedic Medicine & Surgery - BAMS',
            value: 'Bachelor of Ayurvedic Medicine & Surgery - BAMS'
        },
        {
            key: 'Bachelor of Business Administration',
            value: 'Bachelor of Business Administration'
        },
        { key: 'Bachelor of Commerce', value: 'Bachelor of Commerce' },
        {
            key: 'Bachelor of Computer Applications',
            value: 'Bachelor of Computer Applications'
        },
        {
            key: 'Bachelor of Computer Science',
            value: 'Bachelor of Computer Science'
        },
        {
            key: 'Bachelor of Dental Surgery - BDS',
            value: 'Bachelor of Dental Surgery - BDS'
        },

        { key: 'Bachelor of Design', value: 'Bachelor of Design' },
        { key: 'Bachelor of Education', value: 'Bachelor of Education' },
        { key: 'Bachelor of Engineering', value: 'Bachelor of Engineering' },
        { key: 'Bachelor of Fine Arts', value: 'Bachelor of Fine Arts' },
        { key: 'Bachelor of Home Science', value: 'Bachelor of Home Science' },

        {
            key: 'Bachelor of Homeopathic Medicine and Surgery - BHMS',
            value: 'Bachelor of Homeopathic Medicine and Surgery - BHMS'
        },
        { key: 'Bachelor of Laws', value: 'Bachelor of Laws' },
        {
            key: 'Bachelor of Mass Communications',
            value: 'Bachelor of Mass Communications'
        },
        {
            key: 'Bachelor of Medicine and Bachelor of Surgery (MBBS)',
            value: 'Bachelor of Medicine and Bachelor of Surgery (MBBS)'
        },
        { key: 'Bachelor of Nursing', value: 'Bachelor of Nursing' },
        { key: 'Bachelor of Pharmacy', value: 'Bachelor of Pharmacy' },
        { key: 'Bachelor of Physiotherapy', value: 'Bachelor of Physiotherapy' },
        { key: 'Bachelor of Science', value: 'Bachelor of Science' },
        { key: 'Bachelor of Social Work', value: 'Bachelor of Social Work' },
        { key: 'Bachelor of Technology', value: 'Bachelor of Technology' },
        {
            key: 'Bachelor of Veterinary Science & Animal Husbandry',
            value: 'Bachelor of Veterinary Science & Animal Husbandry'
        },
        { key: 'Doctor of Medicine', value: 'Doctor of Medicine' },
        {
            key: 'Doctor of Medicine in Homoeopathy',
            value: 'Doctor of Medicine in Homoeopathy'
        },
        { key: 'Doctor of Pharmacy', value: 'Doctor of Pharmacy' },
        { key: 'Doctorate of Medicine', value: 'Doctorate of Medicine' },
        {
            key: 'General Nursing & Midwifery (GNM)',
            value: 'General Nursing & Midwifery (GNM)'
        },
        { key: 'Bachelor of Journalism', value: 'Bachelor of Journalism' },
        { key: 'ITI', value: 'ITI' },
        { key: 'Other', value: 'Other' }
    ],
    'Post Graduation': [
        { key: 'Master of Agriculture', value: 'Master of Agriculture' },
        { key: 'Master of Arts', value: 'Master of Arts' },
        {
            key: 'Master of Ayurvedic Medicine & Surgery - BAMS',
            value: 'Master of Ayurvedic Medicine & Surgery - BAMS'
        }
    ]
}

class CollapseViewBox extends Component {

    state = {
        cp: true
    }

    render() {
        const { cp } = this.state

        return <React.Fragment>
            <div className={cp ? styles.textarraycollapse : styles.textcollapsenot}>{this.props.children}</div>
            <button style={{ color: 'red', float: 'right' }} onClick={() => {
                this.setState({
                    cp: !cp
                })
            }}>
                {cp ? <p>View More + </p> : <p>View Less - </p>}
            </button>
        </React.Fragment>
    }
}

class CourseReport extends Component {
    state = {
        total: 0,
        loading: false,
        allLevels: [],
        allFaculties: [],
        uniArr: [],
        payableList: [
            { name: 'Semester wise', value: 'Semester wise' },
            { name: 'Annual', value: 'Annual' },
            { name: 'Trimester', value: 'Trimester' }
        ]
    }
    onCountryChoose = v => {
        this.setState({
            preferenceCountryId: v, preferenceStateId: [], preferenceCityId: []
        }, () => {
            setTimeout(() => {
                this.loadStates({
                    id: this.state.preferenceCountryId,
                    type: "All Course"
                })
            }, 500)
        })
    }

    onUniChoose = (v) => {
        this.setState({ courseUniversityId: v }, () => {
        });
    };
    onStateChoose = v => {
        this.setState({
            preferenceStateId: v, preferenceCityId: []
        }, () => {
            setTimeout(() => {
                this.loadCities({ countryId: this.state.preferenceCountryId, stateId: this.state.preferenceStateId })
            }, 500)
        })
    }
    loadStates = (Obj) => {
        if (Obj) {
            return new Promise(async resolve => {
                Request.loadStatesByCountry(Obj)
                    .then((daa) => {
                        let temp = [];
                        _.each(daa.result, (vv) => {
                            temp.push({
                                display: vv.stateName,
                                id: vv._id,
                            });
                        });
                        this.setState({ stateArr: temp });
                    })
                    .catch((err) => {
                    });
            })
        }
    }
    loadCities = (Obj) => {
        if (Obj) {
            return new Promise(async resolve => {
                let data = await Request.loadCitiesForCourseFinder(Obj)
                let temp = []
                _.each(data.result, (vv) => {
                    temp.push({
                        display: vv.cityName,
                        id: vv._id
                    })
                })
                this.setState({ cityArr: temp })
            })
        }
    }
    onCityChoose = v => {
        this.setState({
            preferenceCityId: v
        })
    }
    apiRequest = params => {

        return new Promise(async resolve => {
            params = this.returnNewParams(params)

            this.setState({ exportParams: params })
            if (params.intakes) {
                params.intakes = this.setIntakeFormat(params.intakes)
            }
            let data = await Request.getAllCourseForCoursesReport({
                ...params
            })

            this.setState({ total: data.total })
            resolve(data)
        })
    }

    setIntakeFormat = (v) => {
        let x = '';
        if (v === 'Jan') {
            x = '-01-';
        } else if (v === 'Feb') {
            x = '-02-';
        } else if (v === 'Mar') {
            x = '-03-';
        } else if (v === 'April') {
            x = '-04-';
        } else if (v === 'May') {
            x = '-05-';
        } else if (v === 'June') {
            x = '-06-';
        } else if (v === 'July') {
            x = '-07-';
        } else if (v === 'Aug') {
            x = '-08-';
        } else if (v === 'Sep') {
            x = '-09-';
        } else if (v === 'Oct') {
            x = '-10-';
        } else if (v === 'Nov') {
            x = '-11-';
        } else if (v === 'Dec') {
            x = '-12-';
        }

        return x;
    }

    loadUni = async () => {
        let arr = await Request.loadSimpleUniversities();
        this.setState({ uniArr: arr.arr });
    };

    loadLevels = async () => {
        let params = { sortField: 'levelName', sortOrder: 'ascend', results: 100, count: 100 }
        Request.loadSimpleLevels({ ...params })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.levelName })
                    return temp
                }, [])
                this.setState({ allLevels: resp.data })
            })
            .catch(err => {
                console.log(err)
            })
    }
    loadFaculties = async () => {
        let params = { sortField: 'facultyName', sortOrder: 'ascend', results: 100, count: 100 }
        Request.loadSimpleFaculties({ ...params })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.facultyName })
                    return temp
                }, [])


                this.setState({ allFaculties: resp.data })

            })
            .catch(err => {
                console.log(err)
            })
    }

    loadCountry() {
        let params = {
            results: 100,
            sortField: 'countryName',
            sortOrder: 'ascend'
        }
        Request.getCountriesWithoutAuth(params)
            .then(resp => {
                if (resp) {
                    let temp = []
                    _.each(resp.data, (vv) => {
                        temp.push({
                            display: vv.countryName,
                            id: vv._id
                        })
                    })
                    this.setState({ countryArr: temp })
                }
            })
            .catch(err => {
            })

    }

    reload = () => {
        this.table.current.reload()
    }

    searchReset() {
        this.setState({
            courseUniversityId: [],
            preferenceCountryId: [],
            preferenceStateId: [],
            preferenceCityId: [],
            qualification: '',
            maths: '',
            english: '',
            percentage: '',
            degreeType: '',
            stream: '',
            stateArr: [],
            cityArr: [],
            courseFacultyId: [],
            courseLevelId: '',
            minimumTuitionFees: '',
            maximumTuitionFees: '',
            examType: '',
            overall: '',
            listening: '',
            writing: '',
            reading: '',
            speaking: ''

        }, () => {
            this.reload()
        })
    }

    returnNewParams(params) {
        let {
            courseUniversityId,
            preferenceCountryId,
            preferenceStateId,
            preferenceCityId,
            qualification,
            maths,
            english,
            percentage,
            degreeType,
            stream,
            courseLevelId,
            courseFacultyId,
            minimumTuitionFees,
            maximumTuitionFees,
            examType,
            overall,
            listening,
            writing,
            reading,
            speaking
        } = this.state

        if (courseUniversityId) {
            params['courseUniversityId'] = courseUniversityId
        }
        if (preferenceCountryId) {
            params['universityCountryId'] = preferenceCountryId
        }
        if (preferenceStateId) {
            params['universityStateId'] = preferenceStateId
        }
        if (preferenceCityId) {
            params['universityCityId'] = preferenceCityId
        }
        if (qualification) {
            params['qualification'] = qualification
        }
        if (courseLevelId) {
            params['courseLevelId'] = courseLevelId
        }
        if (courseFacultyId) {
            params['courseFacultyId'] = courseFacultyId
        }
        if (maths) {
            params['mathsMarks'] = maths
        }
        if (english) {
            params['englishMarks'] = english
        }
        if (percentage) {
            params['percentage'] = percentage
        }
        if (degreeType) {
            params['degreeType'] = degreeType
        }
        if (stream) {
            params['stream'] = stream
        }
        if (minimumTuitionFees) {
            params['minimumTuitionFees'] = minimumTuitionFees
        }
        if (maximumTuitionFees) {
            params['maximumTuitionFees'] = maximumTuitionFees
        }
        if (examType) {
            params['examType'] = examType
        }
        if (overall) {
            params['overall'] = overall
        }
        if (listening) {
            params['listening'] = listening
        }
        if (writing) {
            params['writing'] = writing
        }
        if (reading) {
            params['reading'] = reading
        }
        if (speaking) {
            params['speaking'] = speaking
        }
        return params
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.loadUni();
        this.loadLevels()
        this.loadFaculties()
    }

    componentDidMount() {
        this.loadCountry()
    }

    render() {

        const {
            allLevels, allFaculties, payableList, countryArr, cityArr, stateArr,
        } = this.state

        const columns = [
            {
                title: 'Country',
                width: 150,
                key: 'universityCountryName',
                searchTextName: 'universityCountryName',
                filterRegex: true,
                render: (val, row) => {
                    return (
                        <div>{row.universityCountryId ? row.universityCountryName : ''}</div>
                    )
                }
            },
            {
                title: 'State',
                width: 150,
                key: 'universityStateName',
                searchTextName: 'universityStateName',
                filterRegex: true,
                render: (val, row) => {
                    return (
                        <div>{row.universityStateId ? row.universityStateName : ''}</div>
                    )
                }
            },
            {
                title: 'City',
                width: 150,
                key: 'universityCityName',
                searchTextName: 'universityCityName',
                filterRegex: true,
                render: (val, row) => {
                    return (
                        <div>{row.universityCityId ? row.universityCityName : ''}</div>
                    )
                }
            },
            {
                title: 'University',
                width: 150,
                key: 'universityInstitutionName',
                searchTextName: 'universityInstitutionName',
                filterRegex: true,
                render: (val, row) => {
                    return (
                        <div>{row.universityInstitutionName}</div>
                    )
                }
            },
            {
                title: 'Course Name',
                key: 'courseName',
                searchTextName: 'courseName',
                filterRegex: true,
                render: (val, row) => {
                    return (
                        <div>{row.course.courseName}</div>
                    )
                }
            },
            {
                title: 'Code',
                key: 'courseCode',
                width: 100,
                searchTextName: 'courseCode',
                filterRegex: true,
                render: (val, row) => {
                    return (
                        <div>{row.course.courseCode}</div>
                    )
                }

            },
            {
                title: 'Duration',
                key: 'courseDuration',
                searchTextName: 'courseDuration',
                filterRegex: true,
                width: 100,
                render: (val, record) => {
                    return (
                        <div>{record.course.courseDuration}</div>
                    )
                }
            },
            {
                title: 'Stream',
                key: 'stream',
                searchTextName: 'stream',
                filterRegex: true,
                width: 100,
                render: (val, record) => {
                    let streams = [];
                    if (record.course.qualification) {
                        record.course.qualification.forEach(qualification => {
                            let streamArray = (qualification.stream.length > 0 ? qualification.stream.join(', ') : '');
                            if (streamArray) {
                                streams.push(streamArray)
                            }
                        });
                    }
                    return (
                        <div>{streams.join(', ')}</div>
                    )
                }
            },
            {
                title: 'Level',
                key: 'courseLevelId',
                // filters: allLevels && allLevels.map(x => ({ value: x._id, text: x.display })),
                render: (val, record) => {
                    let { courseLevelId } = record.course
                    let levelData = _.find(allLevels, (item) => {
                        return item._id === courseLevelId
                    })
                    return (
                        <div>{levelData ? levelData.display : ''}</div>)
                }
            },
            {
                title: 'Faculty',
                key: 'courseFacultyId',
                // filters: allFaculties && allFaculties.map(x => ({ value: x._id, text: x.display })),
                render: (val, record) => {
                    let { courseFacultyId } = record.course
                    let facultyData = _.find(allFaculties, (item) => {
                        return item._id === courseFacultyId
                    })
                    return (
                        <div>{facultyData ? facultyData.display : ''}</div>)
                }
            },
            {
                title: 'Awarding Body',
                key: 'courseAwardingBody',
                searchTextName: 'courseAwardingBody',
                filterRegex: true,
                render: (val, row) => {
                    return (
                        <div>{row.course.courseAwardingBody}</div>
                    )
                }
            },
            {
                title: 'Course Link',
                key: 'courseURL',
                searchTextName: 'courseURL',
                filterRegex: true,
                render: (val, row) => {
                    return (
                        <div><a href={`${row.course.courseURL}`} target={'_blank'}>{row.course.courseURL}</a></div>
                    )
                }
            },
            {
                title: 'Tuition Fee per year',
                key: 'tutionFee',
                // searchTextName: 'tutionFee',
                filterRegex: true,
                render: (val, row) => {
                    return (
                        <div>{row.course.tutionFee}</div>
                    )
                }
            },
            {
                title: 'Payable',
                key: 'payable',
                filters: payableList && payableList.map(x => ({ value: x.value, text: x.name })),
                // searchTextName: 'payable',
                // filterRegex: true,
                render: (val, row) => {
                    return (
                        <div>{row.course.payable}</div>
                    )
                }
            },
            {
                title: 'Addl Requirements',
                key: 'additionalRequirements',
                searchTextName: 'additionalRequirements',
                filterRegex: true,
                render: (val, row) => {
                    return (
                        <div>{row.course.additionalRequirements}</div>
                    )
                }
            },
            {
                title: 'English Requirements',
                width: 250,
                key: 'ielts',
                searchTextName: 'English Requirements',
                filterRegex: true,
                render: (val, record) => {
                    if (record && record.course && record.course.ieltsRequirements && record.course.ieltsRequirements.length > 1) {
                        return <CollapseViewBox>
                            {record.course.ieltsRequirements && _.map(record.course.ieltsRequirements, (item, index) => {
                                return (
                                    <div key={index} className={styles.alternateColors}>
                                        <div>
                                            <small>ExamType: {item.ExamType}</small>
                                            {`, ${'\n'}`}
                                            <small>Overall: {item.Overall}</small>
                                            {`, ${'\n'}`}
                                            <small>Reading: {item.Reading}</small>
                                            {`, ${'\n'}`}
                                            <small>Writing: {item.Writing}</small>
                                            {`, ${'\n'}`}
                                            <small>Listening: {item.Listening}</small>
                                            {`, ${'\n'}`}
                                            <small>Speaking: {item.Speaking}</small>
                                        </div>
                                    </div>)
                            })}


                        </CollapseViewBox>

                    } else {
                        return (
                            <div>{record && record.course && record.course.ieltsRequirements && record.course.ieltsRequirements.length > 0 &&
                                record.course.ieltsRequirements.map((item, c) => {
                                    return (
                                        <div key={c} className={styles.alternateColors}>
                                            <div>
                                                <small>ExamType: {item.ExamType}</small>
                                                {`, ${'\n'}`}
                                                <small>Overall: {item.Overall}</small>
                                                {`, ${'\n'}`}
                                                <small>Reading: {item.Reading}</small>
                                                {`, ${'\n'}`}
                                                <small>Writing: {item.Writing}</small>
                                                {`, ${'\n'}`}
                                                <small>Listening: {item.Listening}</small>
                                                {`, ${'\n'}`}
                                                <small>Speaking: {item.Speaking}</small>
                                            </div>
                                        </div>
                                    )
                                })}

                            </div>
                        )
                    }

                }
            },
            {
                title: 'Campus',
                width: 200,
                key: 'selectedCampus',
                // searchTextName: 'selectedCampus',
                render: (val, record) => {

                    if (val && val.length > 1) {
                        return <CollapseViewBox>
                            {val.length && _.map(val, (item, index) => {
                                return (

                                    <div key={index} className={styles.alternateColors}>
                                        <div>
                                            <small>{item.campusName}</small>
                                        </div>
                                    </div>

                                )
                            })}
                        </CollapseViewBox>

                    } else {
                        return (

                            <div>
                                {val && val.length > 0
                                    ? val.map((item, c) => {

                                        return (
                                            <div key={c} className={styles.alternateColors}>
                                                <div>
                                                    <small>{item.campusName}</small>
                                                </div>
                                            </div>
                                        )
                                    })
                                    : null}
                            </div>
                        )
                    }

                }
            },

            {
                title: 'Intakes',
                width: 150,
                key: 'intakes',
                searchTextName: 'intakes',
                render: (val, record) => {
                    return (
                        <div>
                            {record && record.course && record.course.intakes && record.course.intakes.length > 0 ? record.course.intakes.map((val, inde) => {
                                return <span key={inde}>{moment(val).format('MMM')}{`, ${'\n'}`}</span>
                            }) : null}
                        </div>
                    )
                }
            },
            {
                title: 'Qualification',
                width: 400,
                key: 'qualification',
                searchTextName: 'qualification',
                filterRegex: true,
                render: (val, record) => {
                    if (record && record.course && record.course.qualification && record.course.qualification.length > 1) {
                        return <CollapseViewBox>
                            {record.course.qualification && _.map(record.course.qualification, (item, index) => {
                                return (

                                    <div key={index} className={styles.alternateColors}>
                                        <div>
                                            <small>Qualification: :{item.qualification}</small>
                                            {`, ${'\n'}`}
                                            <small>Percentage :{item.percentage}</small>
                                            {`, ${'\n'}`}
                                            <small>Maths :{item.maths}</small>
                                            {`, ${'\n'}`}
                                            <small>English :{item.english}</small>
                                            {`, ${'\n'}`}
                                            <small>Backlogs :{item.backlogs}</small>
                                            {`, ${'\n'}`}
                                            <small>DegreeType :{item.degreeType}</small>
                                            {`, ${'\n'}`}
                                            <small>Major :{item.major}</small>
                                            {`, ${'\n'}`}
                                            <small>PassingYear :{item.passingYear}</small>
                                            {`, ${'\n'}`}
                                            <small>Stream :{item.stream.join()}</small>
                                        </div>
                                    </div>
                                )
                            })}
                        </CollapseViewBox>
                    } else {
                        return (
                            <div>
                                {record && record.course && record.course.qualification && record.course.qualification.length > 0
                                    ? record.course.qualification.map((item, c) => {
                                        return (
                                            <div key={c} className={styles.alternateColors}>
                                                <div>
                                                    <small>Qualification: :{item.qualification}</small>
                                                    {`, ${'\n'}`}
                                                    <small>Percentage :{item.percentage}</small>
                                                    {`, ${'\n'}`}
                                                    <small>Maths :{item.maths}</small>
                                                    {`, ${'\n'}`}
                                                    <small>English :{item.english}</small>
                                                    {`, ${'\n'}`}
                                                    <small>Backlogs :{item.backlogs}</small>
                                                    {`, ${'\n'}`}
                                                    <small>DegreeType :{item.degreeType}</small>
                                                    {`, ${'\n'}`}
                                                    <small>Major :{item.major}</small>
                                                    {`, ${'\n'}`}
                                                    <small>PassingYear :{item.passingYear}</small>
                                                    {`, ${'\n'}`}
                                                    <small>Stream :{item.stream}</small>
                                                </div>
                                            </div>
                                        )
                                    })
                                    : null}
                            </div>
                        )
                    }

                }
            },
            {
                title: 'Pathways',
                width: 600,
                key: 'pathways',
                searchTextName: 'pathways',
                filterRegex: true,
                render: (val, record) => {

                    if (record && record.course && record.course.pathways && record.course.pathways.length > 1) {
                        return <CollapseViewBox>
                            {record.course.pathways && _.map(record.course.pathways, (item, index) => {
                                return (

                                    <div key={index} className={styles.alternateColors}>
                                        <div>
                                            <small>Course :{item.pathCourse}</small>
                                            {`, ${'\n'}`}
                                            <small>University :{item.pathUniversity}</small>
                                            {`, ${'\n'}`}
                                            <small>Deposit :{item.pathDeposit}</small>
                                            {`, ${'\n'}`}
                                            <small>Duration :{item.pathDuration}</small>
                                            {`, ${'\n'}`}
                                            <small>Url :{item.pathwayUrl}</small>
                                        </div>
                                    </div>

                                )
                            })}
                        </CollapseViewBox>

                    } else {
                        let course = record && record.course
                        return (

                            <div>
                                {course.pathways && course.pathways.length > 0
                                    ? course.pathways.map((item, c) => {

                                        return (
                                            <div key={c} className={styles.alternateColors}>
                                                <div>
                                                    <small>Course :{item.pathCourse}</small>
                                                    {`, ${'\n'}`}
                                                    <small>University :{item.pathUniversity}</small>
                                                    {`, ${'\n'}`}
                                                    <small>Deposit :{item.pathDeposit}</small>
                                                    {`, ${'\n'}`}
                                                    <small>Duration :{item.pathDuration}</small>
                                                    {`, ${'\n'}`}
                                                    <small>Url :{item.pathwayUrl}</small>
                                                </div>
                                            </div>
                                        )
                                    })
                                    : null}
                            </div>
                        )
                    }

                }
            }
        ]


        return (
            <PageHeaderWrapper title={`
          Total Courses : ${this.state.total}`}>


                <Card style={{ marginBottom: 10 }}
                    title="Course Report - Apply filters as required to shortlist programs."
                    headStyle={{ paddingTop: '5px' }}
                    bordered={false}>
                    <Row>
                        <Col span={8}>
                            <label className={styles.test}>Search By University</label>
                            <Select
                                allowClear
                                mode="tags"
                                className={common.width100Pr}
                                showSearch={true}
                                value={this.state.courseUniversityId}
                                placeholder="Select University"
                                optionFilterProp="universityInstitutionName"
                                onChange={this.onUniChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>

                                {this.state.uniArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val._id}>
                                            {val.universityInstitutionName}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Col>
                        <Col span={4}>
                            <label className={styles.test}>Search By Country</label>
                            <Select style={{ width: '90%' }}
                                allowClear
                                mode="tags"
                                className={common.width100Pr}
                                showSearch={true}
                                value={this.state.preferenceCountryId}
                                placeholder="Select Country"
                                optionFilterProp="display"
                                onChange={this.onCountryChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {countryArr && countryArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val.id}>
                                            {val.display}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>
                        <Col span={3}>
                            <label className={styles.test}>Search By State</label>
                            <Select style={{ width: '90%' }}
                                allowClear
                                mode="tags"
                                className={common.width100Pr}
                                showSearch={true}
                                value={this.state.preferenceStateId}
                                placeholder="Select State"
                                optionFilterProp="display"
                                onChange={this.onStateChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {stateArr && stateArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val.id}>
                                            {val.display}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>
                        <Col span={3}>
                            <label className={styles.test}>Search By City</label>
                            <Select style={{ width: '90%' }}
                                allowClear
                                mode="multiple"
                                showSearch={true}
                                className={common.width100Pr}
                                value={this.state.preferenceCityId}
                                placeholder="Select City"
                                optionFilterProp="display"
                                onChange={this.onCityChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {cityArr && cityArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val.id}>
                                            {val.display}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>

                        <Col span={6}>
                            <label className={styles.test}>Search By Qualification</label>
                            <Select style={{ width: '90%' }}
                                allowClear={true}
                                showSearch={true}
                                multi={true}
                                value={this.state.qualification}
                                className={common.width100Pr}
                                placeholder="Select Qualification"
                                onChange={qualification => {
                                    this.setState({
                                        qualification
                                    })
                                }}>
                                <Option value={'X'}>X</Option>
                                <Option value={'XII'}>XII</Option>
                                <Option value={'Diploma'}>Diploma</Option>
                                <Option value={'Bachelor Degree'}>Bachelor Degree</Option>
                                <Option value={'Post Graduation'}>Post Graduation</Option>
                            </Select>
                        </Col>

                    </Row>
                    <Row style={{ marginTop: 10 }}>
                        <Col span={4}>
                            <label className={styles.test}>Search By Faculty</label>
                            <Select style={{ width: '90%' }}
                                allowClear
                                mode={"tags"}
                                showSearch={true}
                                className={common.width100Pr}
                                value={this.state.courseFacultyId}
                                placeholder="Select Faculty"
                                optionFilterProp="display"
                                onChange={(value) => this.setState({ courseFacultyId: value })}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {allFaculties && allFaculties.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val._id}>
                                            {val.display}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>
                        <Col span={4}>
                            <label className={styles.test}>Search By Stream</label>
                            <Select style={{ width: '90%' }}
                                allowClear={true}
                                mode={"tags"}
                                value={this.state.stream}
                                showSearch={true}
                                placeholder="Select Stream"
                                className={common.width100Pr}
                                onChange={streams => {
                                    this.setState({ stream: streams })
                                }}>
                                <Option value={'MEDICAL'}>MEDICAL</Option>
                                <Option value={'NON-MEDICAL'}>NON MEDICAL</Option>
                                <Option value={'COMMERCE'}>COMMERCE</Option>
                                <Option value={'ARTS'}>ARTS</Option>
                            </Select>
                        </Col>
                        <Col span={4}>
                            <label className={styles.test}>Search By Level</label>
                            <Select style={{ width: '90%' }}
                                allowClear
                                showSearch={true}
                                className={common.width100Pr}
                                value={this.state.courseLevelId}
                                placeholder="Select Level"
                                optionFilterProp="display"
                                onChange={(value) => {
                                    this.setState({ courseLevelId: value })
                                }}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {allLevels && allLevels.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val._id}>
                                            {val.display}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>


                        <Col span={3}>
                            <label className={styles.test}>% or Grade</label>
                            <InputNumber style={{ width: '90%' }}
                                value={this.state.percentage}
                                allowClear
                                placeholder={'% or Grade'}
                                onChange={py => {
                                    this.setState({ percentage: py })
                                }}
                            />
                        </Col>
                        <Col span={3}>
                            <label className={styles.test}>Math Score</label>
                            <InputNumber style={{ width: '90%' }}
                                value={this.state.maths}
                                placeholder={'Math Score'}
                                allowClear
                                onChange={py => {
                                    this.setState({ maths: py })
                                }}
                            />
                        </Col>
                        <Col span={3}>
                            <label className={styles.test}>English Score</label>
                            <InputNumber style={{ width: '90%' }}
                                value={this.state.english}
                                placeholder={'English Score'}
                                allowClear
                                onChange={py => {
                                    this.setState({ english: py })
                                }}
                            />
                        </Col>

                        <Col span={3}>
                            <label className={styles.test}>Search By Degree</label>
                            <Select style={{ width: '90%' }}
                                mode={"tags"}
                                allowClear={true}
                                showSearch={true}
                                value={this.state.degreeType}
                                className={common.width100Pr}
                                placeholder="Select Degree"
                                onChange={degreeType => {
                                    this.setState({ degreeType })
                                }}>
                                {this.state.qualification && typeofDegree[this.state.qualification] &&
                                    typeofDegree[this.state.qualification].map((val, index) => {
                                        return (
                                            <Option key={index} value={val.value}>
                                                {val.value}
                                            </Option>
                                        )
                                    })}
                            </Select>
                        </Col>

                    </Row>
                    <Row style={{ marginTop: 10 }}>
                        <Col span={4}>
                            <label className={styles.test}>Tuition Fees</label>
                            <Row>
                                <Col span={12}>
                                    <InputNumber style={{ width: '90%' }}
                                        value={this.state.minimumTuitionFees}
                                        placeholder={'Minimum'}
                                        allowClear
                                        className={common.width100Pr}
                                        onChange={py => {
                                            this.setState({ minimumTuitionFees: py })
                                        }}
                                    />
                                </Col>
                                <Col span={12}>
                                    <InputNumber style={{ width: '90%' }}
                                        value={this.state.maximumTuitionFees}
                                        placeholder={'Maximum'}
                                        allowClear
                                        className={common.width100Pr}
                                        onChange={py => {
                                            this.setState({ maximumTuitionFees: py })
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col span={4}>
                            <label className={styles.test}>Exam Type</label>
                            <Select style={{ width: '90%' }}
                                placeholder={'Choose Exam'}
                                value={this.state.examType}
                                allowClear
                                className={common.width100Pr}
                                onChange={ei => {
                                    this.setState({ examType: ei })
                                }}>
                                <Option value={'IELTS'}>IELTS</Option>
                                <Option value={'PTE'}>PTE</Option>
                                <Option value={'TOEFL'}>TOEFL</Option>
                                <Option value={'CAE'}>CAE</Option>
                            </Select>
                        </Col>
                        <Col span={4}>
                            <label className={styles.test}>Overall</label>
                            <InputNumber style={{ width: '90%' }}
                                value={this.state.overall}
                                placeholder={'Overall'}
                                allowClear
                                onChange={py => {
                                    this.setState({ overall: py })
                                }}
                            />
                        </Col>

                        <Col span={3}>
                            <label className={styles.test}>Listening</label>
                            <InputNumber style={{ width: '90%' }}
                                value={this.state.listening}
                                placeholder={'Listening'}
                                allowClear
                                onChange={py => {
                                    this.setState({ listening: py })
                                }}
                            />
                        </Col>

                        <Col span={3}>
                            <label className={styles.test}>Reading</label>
                            <InputNumber style={{ width: '90%' }}
                                value={this.state.reading}
                                placeholder={'Reading'}
                                allowClear
                                onChange={py => {
                                    this.setState({ reading: py })
                                }}
                            />
                        </Col>

                        <Col span={3}>
                            <label className={styles.test}>Writing</label>
                            <InputNumber style={{ width: '90%' }}
                                value={this.state.writing}
                                placeholder={'Writing'}
                                allowClear
                                onChange={py => {
                                    this.setState({ writing: py })
                                }}
                            />
                        </Col>

                        <Col span={3}>
                            <label className={styles.test}>Speaking</label>
                            <InputNumber style={{ width: '90%' }}
                                value={this.state.speaking}
                                placeholder={'Speaking'}
                                allowClear
                                onChange={py => {
                                    this.setState({ speaking: py })
                                }}
                            />
                        </Col>

                    </Row>
                    <Row style={{ marginTop: 10 }}>
                        <Col span={24} >
                            <Button type={'default'}
                                loading={this.props.loading}
                                onClick={() => {
                                    this.searchReset()
                                }}>Reset</Button>
                            <Button type={'default'}
                                loading={this.props.loading}
                                onClick={() => {
                                    this.reload()
                                }}>Search</Button>

                        </Col>

                    </Row>


                </Card>

                <Card bordered={true}>
                    <TableComp
                        columns={columns}
                        rowKey={(item, x) => {
                            return x
                        }}
                        id={'courseReport'}
                        extraProps={{ scroll: { x: 4000 } }}
                        ref={this.table}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CourseReport)
